import { THUMB_CARD_SIZE, THUMB_COMMENT_SIZE } from '../../../../../../../const';

export const COMMENT_ATTACHMENT_GOOGLE_THUMB_SIZE = `s${THUMB_CARD_SIZE}`;
export const COMMENT_ATTACHMENT_FS_GOOGLE_THUMB_SIZE = `s${THUMB_COMMENT_SIZE}`;
